import React, { Component } from 'react';
import classnames from 'classnames';
import logoImg from './logo.svg';
import { Link } from 'react-router';
import styles from './Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer className="container">
        <div className={classnames(styles.footerContainer, "row")}>
          <div className="col--s-3of12">
            <img src={logoImg} alt="footer logo" />
          </div>
          <div className="col--s-3of12 col--s-offset-1of12">
            <p className={styles.contactUs}>Contact Us</p>
            <p className={styles.contactInfo}>
              hello@fivemetalshop.com<br />
              +886-2-23569377<br />
              GMT+8 11:00－20:00
            </p>
          </div>
          <div className="col--s-3of12">
            <p className={styles.linkTo}><Link to="/projects/tags">All Projects</Link></p>
            <p className={styles.linkTo}><Link to="/about">About</Link></p>
            <p className={styles.linkTo}><Link to="/journal">Journal</Link></p>
            <p className={styles.linkTo}><Link to="/contact">Contact</Link></p>
          </div>
          <div className="col--s-2of12">
            <p className={styles.social}>Social</p>
            <p className={styles.socialLink}>
              <a href="https://www.facebook.com/FiveMetalShop" target="_blank" rel="noopener noreferrer">Facebook</a>
            </p>
            <p className={styles.socialLink}>
              <a href="https://www.pinterest.com/fivemetalshop" target="_blank" rel="noopener noreferrer">Pinterest</a>
            </p>
            <p className={styles.socialLink}>
              <a href="https://www.instagram.com/fivemetalshop" target="_blank" rel="noopener noreferrer">Instagram</a>
            </p>
          </div>
        </div>
        <p className={styles.copyright}>Copyright © 2018 Five Metal Shop</p>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js